import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import * as moment from 'moment';
import { NeworderindoorPage } from '../neworderindoor/neworderindoor';

/**
 * Generated class for the PreorderindoorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-preorderindoor',
  templateUrl: 'preorderindoor.html',
})
export class PreorderindoorPage {
  loadingData: boolean = true
  loadingImport: boolean = true
  DataImported = []
  _ref
  mdl

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public alertCtrl: AlertController, public modalCtrl: ModalController, public toastCtrl: ToastController) {
    this._ref = this.navParams.get('r')
  }

  ionViewDidLoad() {
    this.loadDataImported()
  }

  importOrders() {
    this.loadingImport = false
    var _that = this
    this.gn._Post('/api/importorders', { refreshall: this.gn.crypt(true), cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that.loadingImport = true
      if (_data.msg == 'no more') {
        let toast = _that.toastCtrl.create({
          message: _that.dic.l["noNewOrders"],
          duration: 3000,
          position: 'top'
        });
        toast.present();
      } else {
        _that.loadDataImported()
      }
    })
  }

  loadDataImported() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getrouteindoor', { today: this.gn.crypt(true), cid: this.gn.crypt(this.gn.user.ClientId), status: this.gn.crypt(-1) }, function (_data) {
      _that.loadingData = false
      _that.DataImported = []

      for (var i = 0; i < _data.length; i++) {
        _data[i].datumcreate = moment(_data[i].dt_create).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].datum = moment(_data[i].dt).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].dt).format(_that.gn.user.TFormat)
        _data[i].dt_done = moment(_data[i].dt_done).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].cartnames = (_data[i].cartnames + '' == '' || _data[i].cartnames == null) ? '/' : _data[i].cartnames
        _data[i].visible = true;

        if (_data[i].statuspin == null) {
          _data[i].productpath1 = _that.dic.l["productionPath"]
          _data[i].productpath2 = _that.dic.l["notStarted"]
        }
        if (_data[i].statuspin + '' == '2') {
          _data[i].productpath1 = _that.dic.l["productionPath"]
          _data[i].productpath2 = _that.dic.l["gCompleted"]
        }
        if (_data[i].statuspin + '' == '0') {
          _data[i].productpath1 = _that.dic.l["process"]
          _data[i].productpath2 = _data[i].processname + ' - ' + _that.dic.l["completed1"]
        }
        if (_data[i].statuspin + '' == '1') {
          _data[i].productpath1 = _that.dic.l["process"]
          _data[i].productpath2 = _data[i].processname + ' - ' + _that.dic.l["inprogress"]
        }

        _that.DataImported.push(_data[i])
      }
      //debugger;
    })
  }

  getItems(ev: any) {
    // for (var i=0; i<this.Data.length; i++){
    //   this.Data[i].visible = true
    // }  
    var val = ''
    if (ev.target.value != undefined) {
      val = ev.target.value.toLowerCase()
    }

    for (var i = 0; i < this.DataImported.length; i++) {
      if (val == '') {
        this.DataImported[i].visible = true
      } else {
        var itm = this.DataImported[i].title.toLowerCase()
        var itm1 = this.DataImported[i].article.toLowerCase()
        var itm2 = ''
        if (this.DataImported[i].cartnames != null)
          itm2 = this.DataImported[i].cartnames.toLowerCase()
        var itm3 = ''
        if (this.DataImported[i].kreiral != null)
          itm3 = this.DataImported[i].kreiral.toLowerCase()
        var itm4 = ''
        if (this.DataImported[i].komentar != null)
          itm4 = this.DataImported[i].komentar.toLowerCase()

        if (this.gn._latcyr(itm).indexOf(val) > -1 || this.gn._cyrlat(itm).indexOf(val) > -1 ||
          this.gn._latcyr(itm1).indexOf(val) > -1 || this.gn._cyrlat(itm1).indexOf(val) > -1 ||
          this.gn._latcyr(itm2).indexOf(val) > -1 || this.gn._cyrlat(itm2).indexOf(val) > -1 ||
          this.gn._latcyr(itm3).indexOf(val) > -1 || this.gn._cyrlat(itm3).indexOf(val) > -1 ||
          this.gn._latcyr(itm4).indexOf(val) > -1 || this.gn._cyrlat(itm4).indexOf(val) > -1) {
          this.DataImported[i].visible = true
        } else {
          this.DataImported[i].visible = false
        }
      }

    }

  }

  formatSec(_sec) {
    // console.log(_sec)
    var date = new Date(null); date.setSeconds(_sec);
    var result = date.toISOString().substr(11, 8);
    return result
  }
  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/preorderindoor/preorderindoor.ts